module.exports = __webpack_public_path__ + "img/card-1.5fc768f1.jpg";